'use client';

import { useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import posthog from 'posthog-js';
import { Button } from '@/components/ui/button';

type LoginButtonProps = {
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon';
};

export function LoginButton({ className = 'w-full', size = 'lg' }: LoginButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const searchParams = useSearchParams();

  const handleSignIn = async () => {
    try {
      setIsLoading(true);
      const callbackUrl = searchParams.get('callbackUrl') || '/';
      // Don't capture the raw callbackUrl — it can contain patient/encounter
      // ids when an unauthenticated deep link bounces here. The destination's
      // own $pageview captures it after auth, covered by the BAA comment.
      posthog.capture(
        'auth:login_button_click',
        { has_callback: callbackUrl !== '/' },
        { send_instantly: true },
      );
      await signIn('microsoft-entra-id', { redirectTo: callbackUrl });
    } catch (error) {
      console.error('Sign in error:', error);
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleSignIn}
      disabled={isLoading}
      className={className}
      size={size}
    >
      {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
    </Button>
  );
}
